/**
 * @Author: v_jppjpeng
 * @Date: 2022-9-28 18:04:47
 * @Explain: 细分管理
 */
import type { HttpResponse } from '../data.d';
import http from '../http';

const MODEL = '/filterGroup';
const NEW_MODEL = '/filter_group';

export default {
  // 列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, { isBulitin: false, ...data });
  },
  // 新增
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/add`, data);
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/update`, data);
  },
  // 删除
  onDel(data: { id: number }) {
    return http.post(`${MODEL}/delete`, data);
  },
  // 获取条件配置
  // getFilterConfig(data = {}) {
  //   return http.post(`${MODEL}/get-filter-config`, data);
  // },
  getFilterConfig(
    data: {
      // 获取针对测试玩家的个性化测试状态条件
      isTester?: boolean;
      // 获取不同版本的分层配置：v2.0、v1.0。差异在number、来源类型字段配置
      version?: string;
    } = {},
  ) {
    return http.post(`${NEW_MODEL}/get_filter_config`, data, {
      params: { switchReqToUnderline: true, ver: 'v2' },
    });
  },
  // 详情
  getDetails(data: { id: number }) {
    return http.post(`${MODEL}/detail`, data);
  },
  // 检查分层规则名称是否存在
  checkName(data: {
    segmentTitle: string;
    segmentId?: number;
  }): Promise<HttpResponse> {
    return http.post(`${MODEL}/check-name`, data);
  },
  // 检查分层规则是否存在
  checkSegmentExist(data: {
    tagId: string;
    // source: string;
    // fromFile: boolean;
  }) {
    return http.post(`${MODEL}/check-segment-exist`, data);
  },
  // 获取订阅人数
  getSubscribers(data: { segmentId: number }) {
    return http.post(`${MODEL}/seg-sub-count`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取内置分层列表
  getBuiltInList(data = {}) {
    return http.post(`${MODEL}/bulitin`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 获取全量分层列表数据
  getAllSegment(data: Record<any, any>) {
    return http.post(`${NEW_MODEL}/get_all_segments`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
